export default "__VITE_ASSET__f492f81c__"